import React from "react";
import { FaServer } from "react-icons/fa";
class CustomizedServices extends React.Component {
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaServer className="c-placeholder c-green" />,
      Title: "Služby na míru",
      SubTitle: "",
    });
  }
  render() {
    return (
        <div>

        <div>
            <div>
                <h5>
                    Oprava na počkání
                </h5>
                <br />
                <p>
                    Mnoho oprav jsme schopni řešit jako tzv. expresní opravy, to je do 90 minut až 3 hodiny, dle modelu telefonu. Jsou zpoplatněny 300,-Kč vč. DPH. Pokud nebudeme schopni opravu dokončit do 90 minut, je oprava samozřejmě vyřízena bez poplatku za expresní opravu.
                </p>
                <br />
                <p>
                    Expresní opravy přijímáme vždy pouze do 13:00 hod. Bohužel ne všechny opravy je možno provádět na počkání. O tom, zda závadu na Vašem přístroji je možné zařadit mezi expresní opravy, rozhodne vždy pracovník osobního příjmu.
                    Obecně je možné říci, že na počkání provádíme:
                </p>
                <br />
                <p>
                    Prasklé LCD<br />
                    Přehrání SW<br />
                    Výměna reproduktoru, sluchátka<br />
                    Kosmetické vady, výměna krytů a klávesnic<br />
                    Vadný dotykový panel<br />
                </p>
                <br />
                <p>
                    Pokud Vaše zařízení vykazuje závady, u nichž je diagnostika příčiny závady nebo samotná oprava složitější a tudíž časově náročnější (např. problémy se signálem, s Bluetooth, vypínání přístroje, veškeré občasně se projevující závady, nebo nejde-li přístroj vůbec zapnout), je nutné počítat s delší dobou opravy.
                </p>
                <br />
                <p>
                    Zda bude možno přijmout Váš přístroj k expresní opravě, můžete také zjistit na e-mailové adrese mobil@britex.cz nebo telefonním čísle 312 242 415-9. Stejné kontaktní údaje můžete využít pro zjištění přibližné ceny nezáruční opravy či dostupnosti zboží.
                </p>
            </div>
        </div>
        <br />
        <br />
        <br />
        <div class="row">
            <div class="col-12">
                <h5>
                    Záloha / obnovení / přenesení dat
                </h5>
                <br />
                <p>
                    Máte rozbitý telefon nebo tablet a nechcete přijít o svá data? Pořídili jste si nový přístroj a potřebujete do něj zkopírovat data z toho starého?
                    V 90% případů Vám dokážeme pomoci se zálohou dat, ať už se jedná o přenesení do nového přístroje nebo obnovení dat do původního zařízení po opravě. Zálohujeme telefonní seznam, SMS, obrázky, video, mp3 případně např. poznámky a jiné.
                    I v případě, že Váš přístroj není plně funkční (například poškozený displej), umíme Vaše data zachránit.
                    Zálohy dat provádíme zpravidla na počkání nebo dle dohody, cena služby je 363,-Kč vč. DPH.
                </p>
            </div>
        </div>
        <br />
        <br />
        <br />
        <div class="row">
            <div class="col-12">
                <h5>
                    Správa mobilního parku pro Vaši firmu
                </h5>
                <br />
                <p>
                    Portfolio opravovaných značek: Apple, alcatel, Blackberry, nubia, Huawei, honor, ZTE, Samsung včetně notebooků a netbooků Samsung.
                    <br />Nabízíme:
                </p>
                <br />
                <p>
                    Řešení reklamací mobilních telefonů, tabletů i notebooků a netbooků<br />
                    Evidence Vašich záručních listů a prodejních dokladů<br />
                    Možnost zadávání reklamací do našeho systému prostřednictvím jednoduchého programu<br />
                    Možnost zápůjčních přístrojů po dobu řešení reklamace<br />
                    Bezplatná záloha dat z přístroje do přístroje<br />
                    Nastavená individuální přeprava (LogBox)<br />
                    Možnost sledování stavu zakázky s možností tisku servisních zpráv prostřednictvím VIP portálu<br />
                    Nabídka prodeje zvýhodněných telefonů a tabletů pro zaměstnance<br />
                    Nabídka akčních slev pro Vaše zaměstnance na produkty Audio – Video techniky Samsung od společnosti Britex – CZ s.r.o.<br />
                    Řešení dotazů, podnětů a stížností s přiděleným zástupcem<br />
                </p>
                <br />
                <p>
                    V případě vašeho zájmu o tuto službu, kontaktujte nás na emailové adrese mobil@britex.cz
                </p>
                <br />
                <p>
                    Společnosti využívající správu mobilního parku
                </p>
                <br />
                {/* <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <img src="/img_new/smp/ge.gif" style="max-width: 200px !important;" />
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <img src="/img_new/smp/szdc.jpg" class="rounded-circle" style="max-width: 200px !important;" />
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <img src="/img_new/smp/ceps.png" style="max-width: 200px !important;" />
                    </div>
                </div> */}
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <div class="row">
            <div class="col-12">
                <h5>
                    Virtuální sídlo pro Vaši společnost
                </h5>
                <br />
                <br />
                <p class="text-left offset-xl-1">
                    Aby Vás mohla tato nabídka oslovit, musíte znát odpovědi na nejčastější otázky spojené s tímto institutem.<br />
                </p>
                <br />
                <p class="text-left offset-xl-2">
                    <strong>1. Co je virtuální sídlo společnosti?</strong><br />
                </p>
                <br />
                <p class="text-left offset-xl-3">
                    Jde o alternativu klasického sídla Vaší společnosti. V našich prostorách Vám zajistíme vše, co nabízí standardní sídlo společnosti aniž by byla nezbytná Vaše osobní přítomnost. Virtuální sídlo Vaší společnosti Vám umožní nechat si na naší adresu zaregistrovat sídlo své firmy. Náš personál Vám zajistí osobní styk s Vašimi návštěvami, přijme každý Vám určený telefonní hovor, zaeviduje a zprostředkuje předání každé zásilky určené Vaší společnosti.<br />
                </p>
                <br />
                <p class="text-left offset-xl-2">
                    <strong>2. Splňuje naše nabídka virtuálního sídla Vaší společnosti zákonné požadavky?</strong><br />
                </p>
                <br />
                <p class="text-left offset-xl-3">
                    Námi nabízená služba virtuálního sídla Vaší firmy splňuje všechny zákonné podmínky pro sídlo společnosti.<br />
                </p>
                <br />
                <p class="text-left offset-xl-4">
                    <i class="fa fa-terminal">&nbsp;</i> §31 odst. 16 Živnostenského zákona – zajistíme vyzvednutí a následně zprostředkujeme předání písemností zasílaných na adresu Vaší společnosti<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> např. §31 odst. 2 a 3 Živnostenského zákona - zajistíme kontakt Vaší společnosti s veřejností a státními orgány<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> (§31 odst. 2 Živnostenského zákona) – jsme prokazatelným vlastníkem nemovitosti, v níž je sídlo Vaší společnosti<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Vaše firma bude viditelně označena na naší budově<br /><br />
                </p>
                <br />
                <p class="text-left offset-xl-2">
                    <strong>3. Je to služba pro mne?</strong><br />
                </p>
                <br />
                <p class="text-left offset-xl-3">
                    Rozhodně ano, pokud patříte do některé z následujících skupin společností<br />
                </p>
                <br />
                <p class="text-left offset-xl-4">
                    <i class="fa fa-terminal">&nbsp;</i> Nové a začínající společnosti<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Společnosti, které ke své činnosti nepotřebují pevnou kancelář<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Společnost, jejíž výkon činnosti probíhá zejména na cestách a administrativní servis využívají pouze zřídka<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Firmy rozšiřující působnost do nových oblastí<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Osoby, které sídlo svého podnikání nechtějí registrovat na adresu svého bydliště<br /><br />
                </p>
                <br />
                <p class="text-left offset-xl-2">
                    <strong>4. V čem je přínos virtuálního sídla mé společnosti?</strong><br />
                </p>
                <br />
                <p class="text-left offset-xl-3">
                    <i class="fa fa-terminal">&nbsp;</i> Získáte adresu společnosti v zajímavé lokalitě.<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Zlevní a usnadní Vám rozvoj Vaší společnosti v nových oblastech.<br /><br />
                    <i class="fa fa-terminal">&nbsp;</i> Sníží se režijní náklady na provoz Vaší společnosti.<br /><br />
                </p>
                <br />
                <p class="text-left offset-xl-1">
                    Základní cena 600,- Kč za jeden měsíc neobsahuje doplňkové služby jako přeposílání pošty nebo pronájem prostor pro schůzku s klientem, ale pouze poskytnutí adresy a příjem spolu s evidencí veškeré příchozí komunikace. Pokud budete mít o podobné doplňkové služby zájem, neváhejte nás se svými požadavky oslovit.<br />
                </p>
            </div>
        </div>
    </div>
    );
  }
}

export default CustomizedServices;
